import { cn } from "@/lib/utils";

/**
 * 통화 코드 표기 문자열("KRW 652,300", `formatWithCodeFromSource` 결과)을 코드는 작고 옅게,
 * 숫자는 부모 글자 크기 그대로 나눠 그린다 — 좁은 칸(허브 행 3칸 요금 등)에서 코드가 숫자만큼
 * 자리를 먹지 않게(10-15). 코드 모양이 아니면 문자열 그대로.
 *
 * 부모가 `whitespace-nowrap` · 숫자 크기·굵기를 정한다. 환율 변환 값은 SSR 과 첫 클라이언트
 * 렌더가 다를 수 있어 글자를 품은 두 span 모두 suppressHydrationWarning.
 */
export function CurrencyCodeAmount({
  value,
  codeClassName,
  amountClassName,
}: {
  value: string;
  codeClassName?: string;
  amountClassName?: string;
}) {
  const match = /^([A-Z]{3}) (.+)$/.exec(value);
  if (!match) return <>{value}</>;
  return (
    <>
      <span
        className={cn("mr-0.5 text-[10px] font-medium text-gray-500", codeClassName)}
        suppressHydrationWarning
      >
        {match[1]}
      </span>
      <span className={amountClassName} suppressHydrationWarning>
        {match[2]}
      </span>
    </>
  );
}

/** 숫자 부분 글자 수 — 칸이 좁을 때 숫자 글자를 한 단계 줄일지 판단한다. */
export function currencyAmountLength(value: string): number {
  const match = /^[A-Z]{3} (.+)$/.exec(value);
  return (match ? match[1] : value).length;
}
